import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-200" role="contentinfo">
      {/* Newsletter Section */}
      <div className="border-b border-foreground-700/50">
        <div className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="font-heading text-xl md:text-2xl text-background-50 mb-2">
                订阅吃瓜快报
              </h3>
              <p className="text-sm text-foreground-400">
                每日精选最热黑料，第一时间推送至您的邮箱
              </p>
            </div>
            <form
              onSubmit={(event) => event.preventDefault()}
              className="flex w-full md:w-auto gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                required
                className="flex-1 md:w-64 px-4 py-2.5 bg-foreground-800 border border-foreground-700/50 rounded-lg text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="h-field"
              />
              <button
                type="submit"
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap transition-colors"
              >
                订阅
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-lg" />
              </div>
              <span className="font-heading text-lg text-background-50">黑料吃瓜网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              全网热门黑料事件汇总与最新吃瓜爆料资讯一站式浏览平台，每日实时更新，精彩不容错过。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 bg-foreground-800 hover:bg-primary-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-background-50 text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-foreground-800 hover:bg-primary-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-background-50 text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-foreground-800 hover:bg-primary-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-tiktok-line text-background-50 text-sm" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2" aria-label="页脚分类导航">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">快速链接</h4>
            <nav className="flex flex-col gap-2" aria-label="页脚快速链接">
              <Link
                to="/about"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
              >
                关于我们
              </Link>
              <Link
                to="/about#contact"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
              >
                联系我们
              </Link>
              <Link
                to="/about#privacy"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
              >
                隐私政策
              </Link>
              <Link
                to="/about#disclaimer"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
              >
                免责声明
              </Link>
              <a
                href="#"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                rel="nofollow"
              >
                网站地图
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-400 flex-shrink-0">
                  <i className="ri-mail-line text-sm" />
                </div>
                <span className="text-sm text-foreground-400">hello@9288c.com</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-400 flex-shrink-0">
                  <i className="ri-time-line text-sm" />
                </div>
                <span className="text-sm text-foreground-400">周一至周日 9:00-22:00</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-400 flex-shrink-0">
                  <i className="ri-shield-check-line text-sm" />
                </div>
                <span className="text-sm text-foreground-400">本站内容仅供娱乐参考</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-700/50">
        <div className="px-4 md:px-6 py-4 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            © 2026 黑料吃瓜网 9288c.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容来源于网络，仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}
